//#region src/report_schedule_scope.ts
var ReportScheduleScope = /* @__PURE__ */ function(ReportScheduleScope) {
	ReportScheduleScope["Daily"] = "daily";
	ReportScheduleScope["Weekly"] = "weekly";
	ReportScheduleScope["Monthly"] = "monthly";
	return ReportScheduleScope;
}(ReportScheduleScope || {});
//#endregion
export { ReportScheduleScope };

//# sourceMappingURL=report_schedule_scope.js.map